/* Cart line removal v2: trashcan button next to qty stepper.
   Deliberately does NOT touch the theme's plus/minus handlers. */
(function () {
  if (window.__cartRemoveInit) return;
  window.__cartRemoveInit = true;

  var style = document.createElement('style');
  style.textContent = '.cart__item--details .cart__item--qty{display:flex;align-items:center;gap:8px}.cart__item-remove{background:none;border:0;padding:4px;cursor:pointer;color:inherit;opacity:.55;line-height:0}.cart__item-remove:hover{opacity:1}.cart__item-remove[disabled]{opacity:.25;cursor:default}';
  document.head.appendChild(style);

  document.addEventListener('click', function (evt) {
    var btn = evt.target && evt.target.closest ? evt.target.closest('.js-cart-remove') : null;
    if (!btn) return;
    evt.preventDefault();

    var msg = btn.getAttribute('data-confirm') || 'Are you sure you want to remove this item?';
    if (!window.confirm(msg)) return;

    var key = btn.getAttribute('data-key');
    if (!key) return;

    btn.disabled = true;
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart change failed');
      window.location.reload();
    }).catch(function () {
      btn.disabled = false;
    });
  });
})();
